import React, { useState, useRef, useEffect } from 'react';
import { LayoutGrid, Phone, BarChart3 } from 'lucide-react';
import { getBrandName } from '../config/brand';

const PRODUCTS = [
  {
    id: 'support',
    label: 'Support Platform',
    icon: Phone,
    urlKey: 'supportPlatformUrl',
    defaultUrl: 'http://localhost:3000',
  },
  {
    id: 'analytics',
    label: 'Analytics Platform',
    icon: BarChart3,
    urlKey: 'analyticsPlatformUrl',
    defaultUrl: 'http://localhost:3001',
  },
];

const ProductSwitcher = ({ currentApp = 'support' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getProductUrl = (product) => {
    const config = window.APP_CONFIG || {};
    return config[product.urlKey] || product.defaultUrl;
  };

  const handleProductClick = (product) => {
    if (product.id === currentApp) {
      setIsOpen(false);
      return;
    }
    window.location.href = getProductUrl(product);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
        aria-label="Switch product"
      >
        <LayoutGrid size={18} />
        <span className="hidden sm:inline">{getBrandName()}</span>
      </button>

      {isOpen && (
        <div className="absolute left-0 top-full mt-1 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          <div className="px-3 py-2 border-b border-gray-100">
            <p className="text-xs font-medium text-gray-500 uppercase">Switch to</p>
          </div>
          <div className="py-1">
            {PRODUCTS.map((product) => {
              const Icon = product.icon;
              const isCurrent = product.id === currentApp;

              return (
                <button
                  key={product.id}
                  onClick={() => handleProductClick(product)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${
                    isCurrent
                      ? 'bg-primary-50 text-primary-700 font-medium'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <Icon size={18} className={isCurrent ? 'text-primary-600' : 'text-gray-400'} />
                  <span>{product.label}</span>
                  {isCurrent && (
                    <span className="ml-auto text-xs text-primary-500">Current</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductSwitcher;
